import React from "react";
import { LogOut } from "lucide-react";
import { useAuth } from "../App";
import { useNavigate, Link } from "react-router-dom";

export default function Header({ children, breadcrumb }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      className="h-14 md:h-20 border-b-2 border-black bg-white flex items-center justify-between gap-2 px-3 md:px-6 sticky top-0 z-40"
      data-testid="app-header"
    >
      <div className="flex items-center gap-6 min-w-0">
        <Link to="/dashboard" className="flex items-center gap-2 md:gap-3 group" data-testid="logo-link">
          <div className="w-8 h-8 md:w-10 md:h-10 bg-black flex items-center justify-center group-hover:bg-klein transition-colors">
            <span className="text-white font-mono text-[10px] md:text-xs font-bold">NT</span>
          </div>
          <span className="font-heading font-black text-lg md:text-xl tracking-tighter uppercase hidden sm:inline">
            NEW / TRELLO
          </span>
        </Link>
        {breadcrumb && (
          <div className="hidden md:flex items-center gap-3 font-mono text-xs uppercase tracking-wider text-black/60 border-l border-black/20 pl-6">
            {breadcrumb}
          </div>
        )}
      </div>

      <div className="flex items-center gap-2 md:gap-3 shrink-0">
        {children}
        <div className="hidden md:flex items-center gap-3 border-l border-black/20 pl-3 ml-1">
          {user?.picture ? (
            <img
              src={user.picture}
              alt={user.name}
              className="w-9 h-9 border border-black object-cover"
              data-testid="user-avatar"
            />
          ) : (
            <div className="w-9 h-9 bg-canary border border-black flex items-center justify-center font-mono text-xs font-bold">
              {(user?.name || "?").slice(0, 2).toUpperCase()}
            </div>
          )}
          <div className="flex flex-col leading-tight">
            <span className="font-mono text-[10px] uppercase tracking-widest text-black/50">PENGGUNA</span>
            <span className="font-bold text-sm" data-testid="user-name">{user?.name}</span>
          </div>
        </div>
        <button
          onClick={async () => {
            await logout();
            navigate("/login", { replace: true });
          }}
          data-testid="logout-btn"
          title="Keluar"
          className="hidden md:flex w-10 h-10 border border-black items-center justify-center hover:bg-signal hover:text-white hover:-translate-y-0.5 hover:shadow-brut transition-all"
        >
          <LogOut size={16} strokeWidth={2.5} />
        </button>
      </div>
    </header>
  );
}
